import { ArrayInput, SimpleFormIterator } from 'ra-ui-materialui'
import React from 'react'
import LocalizedRichInputText from 'ui-shared/LocalizedFields/LocalizedRichInputText'
import KAccordion from 'ui-shared/accordions/KAccordion'
const HighlightsInput: React.FC = () => (
  <KAccordion accordionTitle="Highlights">
    <ArrayInput source="highlights" label="">
      <SimpleFormIterator>
        <LocalizedRichInputText source="preview" label="form.fields.preview" />
        <LocalizedRichInputText source="content" label="form.fields.content" />
      </SimpleFormIterator>
    </ArrayInput>
  </KAccordion>
)

export default HighlightsInput
